import { useTranslation } from 'react-i18next';
import CameraPermissionSelect from '../camera-permission-select/camera-permission-select';
import MicrophoneCameraPermissionSelect from '../camera-permission-select/camera-permission-select';
import Speaker from '../../../assets/svgs/Speaker.svg';
import Camera from '../../../assets/svgs/Camera.svg';
import 'twin.macro';

const CameraPermissionSelectList = ({
  selectedCameraDefaultLabel,
  setSelectedCamera,
  medaiDevices,
  selectedAudioDefaultLabel,
  setSelectedMicrophone,
  microphones,
  disabled,
}) => {
  const { t } = useTranslation('camera-permission');
  return (
    // shrink-0: the preview above this is the flex item that absorbs the spare
    // height in the camera column, so the picker must keep its natural size.
    <div tw="flex gap-4 items-center w-full md:w-fit shrink-0 mt-4 lg:mt-8">
      <CameraPermissionSelect
        defaultValue={selectedCameraDefaultLabel}
        placeholder={selectedCameraDefaultLabel?.label}
        icon={Camera}
        setSelectedItem={setSelectedCamera}
        list={medaiDevices}
        noDataText={t('select.noCameraFound')}
        disabled={disabled}
      />
      {/* <MicrophoneCameraPermissionSelect
        defaultValue={selectedAudioDefaultLabel}
        placeholder={selectedAudioDefaultLabel?.label}
        icon={Speaker}
        setSelectedItem={setSelectedMicrophone}
        list={microphones}
        noDataText="No Speaker found"
        disabled={disabled}
      /> */}
    </div>
  );
};

export default CameraPermissionSelectList;
